<template>
  <div data-test-id="LiveConsultMediaButtonComponent">
    <div
      class="media-button btn btn-secondary border border-dark rounded d-flex align-items-center p-2"
      :data-test-id="`liveconsultMediaButtonComponent`"
      @click="showModal"
    >
      <b-icon :icon="icon" class="m-2"></b-icon>

      <div class="d-flex flex-column flex-fill text-left ml-2">
        <strong>{{ label }}</strong>
      </div>
      <div v-if="liveConsult.started" class="live-consult-started"></div>
    </div>

    <b-modal ref="media-modal" hide-footer data-event-type="liveconsult" data-test-id="media-modal">
      <template #modal-title>
        <a class="minimize mr-2" @click="minimizeModal">Minimize</a>
        {{ modalTitle }}
      </template>
      <div class="d-block text-center message-center">
        <LiveConsult @modify-case="onModifyCase" @hide-modal="hideModal" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { BIcon } from "bootstrap-vue";
import LiveConsult from "@/Case/components/LiveConsult.vue";
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";
import { showOkDialog } from "@/Utils/Dialogs";

export default {
  name: "LiveConsultMediaButton",
  components: { BIcon, LiveConsult },
  props: {
    label: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      modalTitle: "",
    };
  },
  computed: {
    ...mapGetters("Case", {
      twiageCase: "twiageCase",
      liveConsult: "liveConsult",
    }),
    ...mapGetters("Voip", {
      isVoipCallInProgress: "isCallInProgress",
    }),
  },
  watch: {
    liveConsult: function (newVal, oldVal) {
      if (newVal.started) {
        if (!newVal.minimized && oldVal.minimized) {
          document.querySelector("[data-event-type='liveconsult']").style.display = "block";
        } else if (newVal.minimized && !oldVal.minimized) {
          document.querySelector("[data-event-type='liveconsult']").style.display = "none";
        }
      }
    },
  },
  mounted() {
    this.getLiveConsultTitle();
  },
  methods: {
    showModal() {
      if (this.hasDestinationHospitalSelected()) {
        if (this.hasPermissionToLiveConsult()) {
          this.getLiveConsultTitle();
          if (this.isLiveConsultMinimized()) {
            this.maximizeModal();
          } else {
            if (!this.isVoipCallInProgress) {
              this.$refs["media-modal"].show();
            } else {
              this.showWarning("End current call to start live consult");
            }
          }
        } else {
          this.showWarning(`${this.twiageCase.destinationHospital.name} does not support Live Consults.`);
        }
      } else {
        this.showWarning("Please select a hospital to start Live Consult.");
      }
    },
    hideModal() {
      this.$refs["media-modal"].hide();
    },
    showWarning(message) {
      showOkDialog(this.$bvModal, "Warning", message);
    },
    maximizeModal() {
      this.$emit(CaseEvent.MODIFY, {
        eventType: CaseUpdateEventType.liveConsult,
        data: { liveConsult: { started: true, minimized: false } },
      });
    },
    minimizeModal() {
      this.$emit(CaseEvent.MODIFY, {
        eventType: CaseUpdateEventType.liveConsult,
        data: { liveConsult: { started: true, minimized: true } },
      });
    },
    isLiveConsultMinimized() {
      return this.liveConsult?.started && this.liveConsult?.minimized;
    },
    hasDestinationHospitalSelected() {
      return this.twiageCase?.destinationHospital?.id;
    },
    hasPermissionToLiveConsult() {
      if (this.twiageCase?.destinationHospital?.supportedFeatures) {
        return this.twiageCase.destinationHospital.supportedFeatures.some(
          (feature) => feature.name === "liveConsult" && feature.enabled === true,
        );
      }

      return false;
    },
    onModifyCase(event) {
      this.$emit(CaseEvent.MODIFY, event);
    },
    getLiveConsultTitle() {
      this.modalTitle = "";
      if (this.twiageCase?.complaint?.name) {
        this.modalTitle += `${this.twiageCase.complaint.name} `;
      }
      if (this.twiageCase?.age) {
        this.modalTitle += `${this.twiageCase.age} `;
      }
      if (this.twiageCase?.agePeriod) {
        switch (this.twiageCase.agePeriod) {
          case 3:
            this.modalTitle += "YRS ";
            break;
          case 2:
            this.modalTitle += "MTHS ";
            break;
          case 1:
            this.modalTitle += "WKS ";
            break;
          default:
            break;
        }
      }
      if (this.twiageCase?.gender) {
        this.modalTitle += `[${this.twiageCase.gender}]`;
      }
    },
  },
};
</script>

<style scoped>
.message-center {
  min-height: 400px;
}

.media-button {
  background-color: white;
  color: black;
  min-height: 64px;
}

.media-button .live-consult-started {
  background-color: #28a745;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 5px 6px;
}
</style>
